import styled from 'styled-components';

export const Crop_Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  position: fixed;
`;

export const Crop_Container = styled.div`
  flex: 1;
  position: relative;
  background: #000;
`;
